module.exports = __webpack_public_path__ + "static/media/Heebo-Regular.56936776.ttf";